import { CART_REVAMP_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {string} payload.page_type - The page type where the event is triggered
 * @param {string} payload.product_id - The product ID of the added item
 * @param {string} payload.button_type - The button type that triggered the add action `add_to_cart` or `buy_now`
 * @param {string} payload.type - The item type
 * @param {number} payload.quantity - The quantity of the item added
 * @param {number} payload.price - The price of the item
 * @param {string} payload.variation_id - The variation ID of the item (optional)
 * @param {string} payload.rec_strategy - The recommendation strategy if the item is added from recommendation (optional)
 */
export const onTrackAddItem = async ({
  page_type,
  product_id,
  button_type,
  type,
  quantity,
  price,
  variation_id,
  rec_strategy,
}) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');
  trackerService.track({
    type: CART_REVAMP_TRACKER_TYPE.AddItem,
    data: {
      type,
      page_type,
      button_type,
      product_id,
      quantity,
      price,
      ...(variation_id && { variation_id }),
      ...(rec_strategy && { rec_strategy }),
      scope: 'shop',
      event_category: 'Cart',
    },
  });
};
